import { Routes } from '@angular/router';
import { appFullRoutes } from 'src/app/routes-config/app-routes';

import { NotFoundComponent } from '@features/auth/notfound/notfound.component';

const _COMPONENTS = [NotFoundComponent];

export const appRoutes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () => import('src/app/features/auth/callback/callback.component').then(m => m.AuthCallbackComponent),
  },
  {
    path: 'auth/logout-callback',
    loadComponent: () =>
      import('src/app/features/auth/logout-callback/logout-callback.component').then(m => m.LogoutCallbackComponent),
  },
  ...appFullRoutes,
];
